import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { TEAM_MANAGEMENT_VIEW_PERMISSIONS } from 'dashboard/constants/permissions.js';
import { frontendURL } from 'dashboard/helper/URLHelper.js';
import TeamManagementPage from './pages/TeamManagementPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
  permissions: {
    anyOf: ['administrator', TEAM_MANAGEMENT_VIEW_PERMISSIONS],
  },
};

const teamManagementRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/team-management'),
      component: TeamManagementPage,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'team_management_agents',
            params: to.params,
          }),
        },
        {
          path: 'agents',
          name: 'team_management_agents',
          meta: {
            ...meta,
            hideSecondarySidebar: true,
          },
          component: TeamManagementPage,
        },
      ],
    },
  ],
};

export default teamManagementRoutes;
